import { APPOINTMENT_COPY_KEY } from '@/mixins/appointmentMixin';
import {
  APPOINTMENT_COPY, APPOINTMENT_ORDERS_COUNT, CLEAR_APPOINTMENT_COPY, LOAD_APPOINTMENT_COPY,
} from '@/store/actions/appointments';

/**
 * @description Загрузить скопированную запись.
 * @returns {Object}
 */
const loadAppointmentCopy = () => {
  const appointment = localStorage.getItem(APPOINTMENT_COPY_KEY);
  return appointment ? JSON.parse(appointment) : null;
};

const actions = {
  [APPOINTMENT_COPY]: ({ commit }, appointment) => {
    localStorage.setItem(APPOINTMENT_COPY_KEY, JSON.stringify(appointment));
    commit(APPOINTMENT_COPY, appointment);
  },
  [CLEAR_APPOINTMENT_COPY]: ({ commit }) => {
    localStorage.removeItem(APPOINTMENT_COPY_KEY);
    commit(APPOINTMENT_COPY, null);
  },
  [LOAD_APPOINTMENT_COPY]: ({ commit }) => {
    const appointment = loadAppointmentCopy();
    commit(APPOINTMENT_COPY, appointment);
  },
};

const getters = {
  getAppointmentCopy: (state) => state.appointmentCopy,
  getAppointmentOrdersCount: (state) => state.appointmentOrdersCount,
};

const mutations = {
  [APPOINTMENT_ORDERS_COUNT]: (state, count) => {
    state.appointmentOrdersCount = count;
  },
  [APPOINTMENT_COPY]: (state, appointment) => {
    state.appointmentCopy = appointment;
  },
};

const state = () => {
  const appointmentCopy = loadAppointmentCopy();
  return {
    appointmentCopy,
    appointmentOrdersCount: 0,
  };
};

export default () => ({
  actions,
  getters,
  mutations,
  state,
});
